<abi-back-button class="d-print-none"></abi-back-button>
<button class="ml-1" abiPrint>{{ 'System.Print' | translate }}</button>

<div class="container-fluid px-0 d-print-block printz" [class.d-none]="!useRouting">
  <div class="row mt-3 border">
    <div class="col-3">
      <img [src]="'assets/logos-big/' + tenant + '.svg?v=1'" class="w-100" [alt]="tenant" />
    </div>

    <div class="col-9 text-right">
      <h2>{{ companyName }}</h2>
      <!--class="text-center border-top border-bottom border-secondary"-->

      <p class="pre-wrap mb-1">{{ asTextBlock() }}</p>
      <p class="mb-1">email: {{ email }}</p>
      <p class="mb-1">Tel.: {{ telephone}}</p>
      <p class="mb-1">Fax.: {{ telephone}}</p>
    </div>
  </div>
  <div class="row border-left border-right">
    <div class="col text-center">
      <p class="font-weight-bold">Section 18A Certificate</p>

      Public Benefit Organisation <br>Exemption Reference No.930018388
    </div>
  </div>
  <div class="row border-left border-right">
    <div class="col">
    </div>
  </div>
  <div class="row border-left border-right border-top">
    <div class="col py-4">
      <p class="font-weight-bold">Donations Receipt:</p>
      <p>
        Issued in terms of Section 18A of the Income Tax Act of 1962. The donation received below will be used
        exclusively for the
        objects of the Bedfordview Community Police Forum in carrying out public benefit activities approved in terms of
        Section 18A.
      </p>
      <dl class="row px-0">
        <dt class="col-4">Receipt Number</dt>
        <dd class="col-8">{{ invoiceNumber }}</dd>
        <dt class="col-4">Name of Donor</dt>
        <dd class="col-8">{{ job?.contact | contact }}</dd>

        <dt class="col-4">Address of Donor</dt>
        <dd class="col-8 pre-wrap">{{ job?.address | address }}</dd>


        <ng-template ngFor let-line [ngForOf]="lines" let-i="index">
          <dt class="col-4">Amount of Donation</dt>
          <dd class="col-8">{{ line | jobline:'amount' }}</dd>

          <dt class="col-4">Nature of Donation</dt>
          <dd class="col-8">{{ line.line1 }}</dd>

          <dt class="col-4">Date of Donation</dt>
          <dd class="col-8">{{ line.requested|date }}</dd>

        </ng-template>

        <!--dt class="col-4">Cellphone</dt>
        <dd class="col-8">{{ job?.contact.mobile }}</dd>
        <dt class="col-4">Vat No.</dt>
        <dd class="col-8">{{ job?.contact.instantMessageId }}</dd-->
      </dl>
      <p>
        I confirm that the above donation was received by the Bedfordview Community Police Forum and will be used
        exclusivley for
        objects of conducting a public benefit activity approved by the Minister of Finance in Part II of the Ninth
        Schedule
        to the Income Tax Act.
      </p>
    </div>
  </div>

  <!--div border-top>
    <table class="table">
      <thead>
        <tr>
          <th>
            Type
          </th>
          <th>
            Item ID
          </th>
          <th>
            Description
          </th>
          <th class="text-right">
            Quantity
          </th>
          <th class="text-right">
            Price
          </th>
          <th class="text-right">
            Amount
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let line of lines">
          <td [abiLookupdisplay]="line.typeId" listName="JobLineType">
          </td>
          <td>
            {{ line.itemId }}
          </td>
          <td>
            {{ line.line1 }}
          </td>
          <td class="text-right">
            {{ line.quantityOrdered }}
          </td>
          <td class="text-right">
            {{ line | jobline:'costPrice' }}
          </td>
          <td class="text-right">
            {{ line | jobline:'amount' }}
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr *ngIf="showVat">
          <td colspan="3">
          </td>
          <td class="text-right">
            VAT
          </td>
          <td></td>
          <td class=text-right>{{ vat|number:'1.2-2' }}</td>
        </tr>
        <tr>
          <td colspan="4" class="text-right">
            Total
          </td>
          <td colspan="2" class=text-right>{{ total|number:'1.2-2' }}</td>
        </tr>
      </tfoot>
    </table>

  </div-->
  <div class="row border-left border-right border-bottom justify-content-around pb-4">
    <div class="col-4 text-center">
      <div class="signature">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.4 27.57">
          <path
            d="M41.16 24c14.18-.78 28-2.37 42.06-4.39-.48 1.24-1.34 1.06-1.93 1.14-10 1.43-19.94 2.66-30 3.41-3.06.23-6.12.53-9.18.7-1.12.07-1.42.71-1.61 1.59-.13.6-.26 1.27-1.09 1.16s-.63-.76-.62-1.28c0-1.24-.87-1.12-1.64-1.08-4.57.26-9.14.52-13.71.81a83 83 0 0 1-15.52-.14c-.63-.08-1.53 0-1.66-.77s.85-.83 1.38-1.14 1.56 0 1.43-1-1-.63-1.66-.76c-2.06-.43-4.19-.6-6.1-1.58-1.67-.86-1.76-1.83-.31-3a13 13 0 0 1 3.81-2 173.3 173.3 0 0 1 32.08-8.02 3.75 3.75 0 0 0 2.2-.79c-11.58.83-23.19.58-34.81 1.7.11-1.07.78-.86 1.25-.93 5.07-.84 10.21-.71 15.32-.93 5.6-.25 11.2-.45 16.79-.86h.18c2.75-1.88 5.76 0 8.67-.61 3.09-.7 6.34-.66 9.51-1s6.23-.67 9.34-1.05 6.33-.83 9.5-1.22 6.22-.75 9.33-1.08Q88.58.41 93 .06c.54 0 1.2-.27 1.82.57-2.82 1.1-5.63 1.28-8.39 1.92 5.52 0 11-.07 16.49 1.11a40.28 40.28 0 0 1 4.2 1c1.52.51 1.66 1.37.56 2.56A10 10 0 0 1 105 9.11c-9.45 5.1-19.74 7.65-30.13 9.91a204.6 204.6 0 0 1-32.06 4c-.49-.02-1.11-.2-1.65.98zM89.87 3.5c-2.59-.08-5.18.16-7.76.25a177.53 177.53 0 0 0-38.37 5.44c-1.62.42-2.32 1-2.22 2.79.16 2.89 0 2.86 2.9 2.39 6.95-1.13 13.86-2.53 20.91-3a40.42 40.42 0 0 1 7.93.25c.6.07 1.33.14 1.36.91s-.66.82-1.16 1c-1.32.41-2.65.83-4 1.14-8.79 2.05-17.65 3.8-26.54 5.45-.75.14-1.75.15-1.64 1.25s1.11.75 1.75.71c2.77-.17 5.52-.42 8.29-.62a175.43 175.43 0 0 0 41.21-8 56.94 56.94 0 0 0 13.16-5.9c.57-.37 1.42-.76 1.25-1.6s-1.06-.7-1.67-.84a57 57 0 0 0-15.4-1.62zM8.12 21.36A2.06 2.06 0 0 0 9.83 21c3.24-3 7.31-4.38 11.28-5.93 5.61-2.2 11.4-3.83 17.19-5.5.47-.14 1.25-.14 1.05-.92-.14-.54-.72-.23-1.1-.17a172.92 172.92 0 0 0-32 7.82 11.76 11.76 0 0 0-3.51 1.83c-.91.74-1.14 1.44.19 1.95a32.21 32.21 0 0 0 5.19 1.28zm9.26.27h-1.92c-.54 0-1.12.22-1.25-.39s.56-.79 1-1 .69-.21 1-.31C23.1 18.08 30 16.83 37 15.6c3-.53 3.13-.68 2.91-3.7-.09-1.28-.62-1.5-1.76-1.17a152.77 152.77 0 0 0-21 7.25 24.27 24.27 0 0 0-4.71 2.66c-.28.21-.69.4-.58.82s.57.38.91.44a8.47 8.47 0 0 0 4.61-.27zm55.19-8.87c-5-.9-9.89-.24-14.77.46s-9.87 1.53-14.8 2.33c-.61.1-1.48.17-1.38 1.1.13 1.11 1 .58 1.56.49 3-.45 6-.94 8.92-1.4a2.14 2.14 0 0 1 2.32.5c-4.4 1.17-8.7 1.36-12.67 2.86a264.38 264.38 0 0 0 30.82-6.34zM9.26 25c1.08.11 2.15.3 3.22.33 8.51.19 17-.59 25.45-1.06.47 0 1.12 0 1.08-.64s-.67-.5-1.13-.5c-8.49-.05-17 .84-25.44.89a5.94 5.94 0 0 0-3.18.98zm9.8-4.51a156.76 156.76 0 0 0 17-2.2c1-.15 1.9-.32 2.84-.52a.91.91 0 0 0 .75-1.07c-.06-.64-.56-.53-1-.45-6.55 1.27-13.14 2.38-19.59 4.25zM22 21.88c2.75.85 15.84-1.22 17.24-2.87z" />
        </svg>
      </div>
      <mat-divider></mat-divider> Secretary
    </div>
    <div class="col-4 text-center">
      <div class="signature">
        <br><br> {{ invoiceDate|date }}
      </div>
      <mat-divider></mat-divider> Date
    </div>
  </div>

</div>
